// Общая логика многошаговой формы заявки (FormView, PopapView, FormNoSurprises).
// Компонент задаёт свои настройки через опцию `leadForm`:
//   leadForm: { label, attemptsKey, formId, formName, variant,
//               fixedProject?, projectOptions?, projectStepTitle?, budgetOptions?, projectPrefix? }
// fixedProject — тип проекта задан заранее (лендинг кухонь): шаг «Project» пропускается,
// остальные шаги нумеруются с 1. В шаблоне ориентируйтесь на currentStepKey.
// projectOptions / budgetOptions — свои карточки вместо стандартных ({ value, hint, icon } / строки).
// projectStepTitle — заголовок шага Project (по умолчанию «What are you planning?»).
// projectPrefix — добавляется перед project в Telegram (например, «Kitchen + Bath: »).
// Компонент должен иметь refs: form, stepTitle, zip, phone, email, company.

const TELEGRAM_CHAT_ID = '-4839140753';
const p1 = "https://api.telegram.org/bot";
const p2 = "8154811395:AAGLMPnGmFLW4NrJLeVWSJZzSjyivmFdbn4";
const p3 = "/sendMessage";
const API = p1 + p2 + p3;

// ZIP-коды зоны обслуживания. Если массив пустой — строка про зону в Telegram не выводится.
const SERVICE_ZIPS = [
	'28277', // Ballantyne
	'28173', // Waxhaw, Marvin, Weddington
	'28104', // Weddington, Matthews
	'28105', // Matthews
	'28227', // Mint Hill
	'28075', // Harrisburg
	'28270', // Providence
	'28209', // SouthPark
	'28210', // SouthPark
	'28211', // SouthPark
	'28134', // Pineville
	'28110', // Monroe
	'28111', // Monroe
	'28112', // Monroe
	'28226',
	'28207',
];

const AUTO_ADVANCE_DELAY = 200;
const EMAIL_RE = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

// Простые линейные иконки 24x24 (d-атрибуты для <path>), используются в OptionCard
export const PROJECT_ICONS = {
	kitchen: [
		'M5 3h14a2 2 0 0 1 2 2v14a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2z',
		'M3 8h18',
		'M8 11h8a1 1 0 0 1 1 1v5a1 1 0 0 1-1 1H8a1 1 0 0 1-1-1v-5a1 1 0 0 1 1-1z',
		'M7 5.5h.01',
		'M11 5.5h.01',
	],
	bathroom: [
		'M4 12h16v3a4 4 0 0 1-4 4H8a4 4 0 0 1-4-4v-3z',
		'M6 12V6a2 2 0 0 1 4 0',
		'M7 19l-1 2',
		'M17 19l1 2',
	],
	home: [
		'M3 10.5 12 3l9 7.5',
		'M5 9v11h14V9',
		'M10 20v-6h4v6',
	],
	// Две комнаты рядом: плита слева, ванна справа
	combo: [
		'M4 4h16a1 1 0 0 1 1 1v14a1 1 0 0 1-1 1H4a1 1 0 0 1-1-1V5a1 1 0 0 1 1-1z',
		'M12 4v16',
		'M3 9h9',
		'M6 6.5h.01',
		'M9 6.5h.01',
		'M14 14h5v1.5a2 2 0 0 1-2 2h-1a2 2 0 0 1-2-2V14z',
		'M15 14v-4a1.5 1.5 0 0 1 3 0',
	],
	other: [
		'M21 12a9 9 0 1 1-18 0 9 9 0 0 1 18 0z',
		'M8 12h.01',
		'M12 12h.01',
		'M16 12h.01',
	],
	question: [
		'M21 12a9 9 0 1 1-18 0 9 9 0 0 1 18 0z',
		'M9.5 9.5a2.5 2.5 0 1 1 3.5 2.3c-.6.3-1 .8-1 1.5v.4',
		'M12 17h.01',
	],
};

const PROJECT_OPTIONS = [
	{ value: 'Kitchen', hint: 'Cabinets, counters, layout', icon: PROJECT_ICONS.kitchen },
	{ value: 'Bathroom', hint: 'Shower, vanity, tile', icon: PROJECT_ICONS.bathroom },
	{ value: 'Whole-home remodel', hint: 'Multiple rooms, one project', icon: PROJECT_ICONS.home },
	{ value: 'Other', hint: 'Tell us in the last step', icon: PROJECT_ICONS.other },
];

const BUDGET_OPTIONS = ['$15–30k', '$30–60k', '$60–100k', '$100k+', 'Not sure yet'];
const TIMELINE_OPTIONS = ['ASAP', '1–3 months', '3–6 months', 'Just planning'];

// Все возможные шаги по порядку и их подписи в прогресс-баре
const STEP_KEYS = ['project', 'budget', 'timeline', 'contact'];
const STEP_LABELS = { project: 'Project', budget: 'Budget', timeline: 'Timeline', contact: 'Contact' };

function emptyForm(fixedProject = '') {
	return { project: fixedProject, budget: '', timeline: '', zip: '', name: '', email: '', job: '' };
}

export default {
	data() {
		return {
			step: 1,
			projectOptions: this.$options.leadForm.projectOptions || PROJECT_OPTIONS,
			projectStepTitle: this.$options.leadForm.projectStepTitle || 'What are you planning?',
			budgetOptions: this.$options.leadForm.budgetOptions || BUDGET_OPTIONS,
			timelineOptions: TIMELINE_OPTIONS,

			form: emptyForm(this.$options.leadForm.fixedProject),
			formattedPhone: '+1 ',
			rawPhone: '',

			showError: false,
			timelineError: '',
			zipError: '',
			emailError: '',

			isSending: false,
			sendResult: '',
			leadSource: 'organic / direct'
		};
	},

	mounted() {
		// Источник сохраняется в localStorage роутером при заходе по ссылке с ?utm_source=...,
		// поэтому метка не теряется, даже если клиент успел полазить по другим страницам сайта.
		const source = localStorage.getItem('lead_source');

		if (source) {
			this.leadSource = source;
		}
	},

	computed: {
		stepKeys() {
			return this.$options.leadForm.fixedProject
				? STEP_KEYS.filter(key => key !== 'project')
				: STEP_KEYS;
		},
		stepLabels() {
			return this.stepKeys.map(key => STEP_LABELS[key]);
		},
		totalSteps() {
			return this.stepKeys.length;
		},
		currentStepKey() {
			return this.stepKeys[this.step - 1];
		},
		isValidPhone() {
			return this.rawPhone.length === 10;
		}
	},

	beforeUnmount() {
		clearTimeout(this.advanceTimer);
	},

	methods: {
		// ─── Навигация по шагам ─────────────────────────────
		choose(field, value) {
			this.form[field] = value;
			clearTimeout(this.advanceTimer);
			// Небольшая пауза, чтобы было видно выделение карточки
			this.advanceTimer = setTimeout(this.nextStep, AUTO_ADVANCE_DELAY);
		},

		validateStep() {
			const key = this.currentStepKey;
			if (key === 'project') return !!this.form.project;
			if (key === 'budget') return !!this.form.budget;
			if (key === 'timeline') {
				this.timelineError = this.form.timeline ? '' : 'Please choose when you would like to start.';
				this.zipError = /^\d{5}$/.test(this.form.zip) ? '' : 'Please enter a valid 5-digit ZIP code.';
				if (this.zipError && !this.timelineError) this.$refs.zip.focus();
				return !this.timelineError && !this.zipError;
			}
			return true;
		},

		nextStep() {
			clearTimeout(this.advanceTimer);
			if (this.step >= this.totalSteps || !this.validateStep()) return;

			const { formId, formName, variant } = this.$options.leadForm;
			window.dataLayer = window.dataLayer || [];
			window.dataLayer.push({
				event: 'form_step',
				form_id: formId,
				form_name: formName,
				form_variant: variant,
				form_step: this.step,
			});

			this.sendResult = '';
			this.step++;
		},

		prevStep() {
			clearTimeout(this.advanceTimer);
			if (this.step > 1) this.step--;
		},

		onStepEnter() {
			// Фокус на заголовок шага (для клавиатуры/скринридеров)
			// и подскролл к форме, если её верх ушёл за экран (актуально на мобильных).
			const title = this.$refs.stepTitle;
			if (title) title.focus({ preventScroll: true });

			const formEl = this.$refs.form;
			if (formEl && formEl.getBoundingClientRect().top < 0) {
				formEl.scrollIntoView({ behavior: 'smooth', block: 'start' });
			}
		},

		// Enter в поле ZIP на шаге timeline сабмитит форму — превращаем это в «Continue»
		handleSubmit() {
			if (this.step < this.totalSteps) this.nextStep();
			else this.sendEmailTelegram();
		},

		// ─── Поля ───────────────────────────────────────────
		selectTimeline(value) {
			this.form.timeline = value;
			this.timelineError = '';
		},

		handleZipInput(e) {
			const digits = e.target.value.replace(/\D/g, '').substring(0, 5);
			// Принудительно пишем в DOM: если введена буква, реактивное значение не меняется и Vue не перерисует input
			e.target.value = digits;
			this.form.zip = digits;
			if (this.zipError) this.zipError = '';
		},

		handlePhoneInput(e) {
			if (e.inputType === 'deleteContentBackward') {
				if (this.formattedPhone.length <= 3) this.formattedPhone = '+1 ';
				this.rawPhone = this.formattedPhone.replace(/\D/g, '').substring(1);
				return;
			}
			if (this.showError) this.showError = false;

			let digits = e.target.value.replace(/\D/g, '');
			if (digits.length === 0 || digits[0] !== '1') digits = '1' + digits;
			digits = digits.substring(0, 11);
			this.rawPhone = digits.substring(1);

			let formatted = '+1 ';
			if (digits.length > 1)  formatted += '(' + digits.substring(1, 4);
			if (digits.length >= 4) formatted += ') ';
			if (digits.length > 4)  formatted += digits.substring(4, 7);
			if (digits.length >= 7) formatted += '-' + digits.substring(7, 11);
			this.formattedPhone = formatted;
		},

		resetForm() {
			this.form = emptyForm(this.$options.leadForm.fixedProject);
			this.formattedPhone = '+1 ';
			this.rawPhone = '';
			this.showError = false;
			this.timelineError = '';
			this.zipError = '';
			this.emailError = '';
			this.step = 1;
		},

		// ─── Отправка ───────────────────────────────────────
		async sendEmailTelegram() {
			if (this.isSending) return;

			if (!this.isValidPhone) {
				this.showError = true;
				this.$refs.phone.focus();
				return;
			}
			this.showError = false;

			if (this.form.email && !EMAIL_RE.test(this.form.email)) {
				this.emailError = 'Please enter a valid email address.';
				this.$refs.email.focus();
				return;
			}
			this.emailError = '';
			this.sendResult = '';

			if (this.$refs.company.value) return;

			const { label, attemptsKey, formId, formName, projectPrefix = '' } = this.$options.leadForm;

			const now = Date.now();
			let attempts = JSON.parse(localStorage.getItem(attemptsKey) || '[]');
			attempts = attempts.filter(t => now - t < 60000);
			if (attempts.length >= 3) {
				this.sendResult = '❌ Too many requests. Try again later.';
				return;
			}
			attempts.push(now);
			localStorage.setItem(attemptsKey, JSON.stringify(attempts));

			const { project, budget, timeline, zip, name, email, job } = this.form;
			const phone = this.formattedPhone;
			const lead_source = this.leadSource;

			const zipLines = [`📍 ZIP: ${zip}`];
			if (SERVICE_ZIPS.length) {
				zipLines.push(SERVICE_ZIPS.includes(zip) ? '✅ In service area' : '⚠️ Outside service area');
			}

			const id = Math.random().toString(36).substring(2, 8);
			const text = [
				`ID: ${id}`,
				'📩 New application:',
				'',
				`🏠 Project: ${projectPrefix}${project}`,
				`💰 Budget: ${budget}`,
				`📅 Timeline: ${timeline}`,
				...zipLines,
				'',
				`👤 Full Name: ${name || '—'}`,
				`📞 Phone: ${phone}`,
				`✉️ Email: ${email || '—'}`,
				`💼 Details: ${job.trim() || '—'}`,
				'',
				`📄 Source: ${lead_source}`,
				`📝 Form: ${label}`,
			].join('\n');

			this.isSending = true;
			try {
				const response = await fetch(API, {
					method: 'POST',
					headers: { 'Content-Type': 'application/json' },
					body: JSON.stringify({ chat_id: TELEGRAM_CHAT_ID, text }),
				});

				if (!response.ok) throw new Error(response.statusText);

				window.dataLayer = window.dataLayer || [];
				window.dataLayer.push({
					event: 'form_submit',
					form_id: formId,
					form_name: formName,
					page_path: window.location.pathname,
				});
				this.resetForm();
				this.leadSource = 'organic / direct';
				this.$router.push({
					path: '/thankyou',
					query: { name, phone }
				});
			} catch (error) {
				console.error(error);
				this.sendResult = '❌ Application not sent! Please try again later.';
			} finally {
				this.isSending = false;
			}
		},
	},
};
